import { useCallback, useEffect, useRef, useState } from 'react';
import { useThrottle } from '../useThrottle';
import { observeResize, unobserveResize } from '../utils/globalResizeObserver';
import ddt from '@wix/da-ddt';
/**
 * This is the client only measure
 */ export function useMeasureElement(options = {}) {
    const refNode = useRef(null);
    const [dimensions, setDimensions] = useState({
        width: undefined,
        height: undefined
    });
    const updateDims = useThrottle((dims)=>{
        setDimensions(dims);
    }, [], options.throttle, options.throttleOptions);
    const resized = useCallback((entries)=>{
        const [entry] = entries;
        ddt.log('useMeasureElement', 'Got resize', entry, refNode, entry.target, entries);
        if (entry && entry.borderBoxSize) {
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/borderBoxSize
            const { inlineSize: width, blockSize: height } = entry.borderBoxSize[0];
            // Make sure the width is never bigger than its parent, I don't think we ever
            // want overflow in this dimension, if not probably add a overflowParent prop
            // Also not capping height as generally you do want overflow, again can add
            // match height prop if needed later
            let calcWidth = width;
            if (refNode.current && refNode.current.parentElement) {
                var _refNode_current_parentElement_getBoundingClientRect, _refNode_current_parentElement, _refNode_current;
                const parentWidth = (_refNode_current = refNode.current) === null || _refNode_current === void 0 ? void 0 : (_refNode_current_parentElement = _refNode_current.parentElement) === null || _refNode_current_parentElement === void 0 ? void 0 : (_refNode_current_parentElement_getBoundingClientRect = _refNode_current_parentElement.getBoundingClientRect()) === null || _refNode_current_parentElement_getBoundingClientRect === void 0 ? void 0 : _refNode_current_parentElement_getBoundingClientRect.width;
                if (parentWidth && parentWidth < width) {
                    calcWidth = parentWidth;
                }
            }
            if (options.throttle) {
                updateDims({
                    width: calcWidth,
                    height
                });
            } else {
                setDimensions({
                    width: calcWidth,
                    height
                });
            }
        }
    }, [
        options.throttle,
        updateDims
    ]);
    const ref = useCallback((node)=>{
        if ((node === null || node === void 0 ? void 0 : node.nodeType) === Node.ELEMENT_NODE) {
            refNode.current = node;
            observeResize(node, resized);
        }
    }, [
        resized
    ]);
    useEffect(()=>{
        return ()=>{
            if (refNode.current) {
                unobserveResize(refNode.current, resized);
                refNode.current = null;
            }
        };
    }, [
        resized
    ]);
    return {
        ref,
        dimensions
    };
}

//# sourceMappingURL=useMeasureElement.js.map